<template>
    <v-form v-model="valid" ref="caracteristicasInternas" lazy-validation>
        <v-row>
            <v-col cols="12" sm="6">
                <v-autocomplete label="Pent-House"
                                :items="constants.pentHouse"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete label="Duplex"
                                :items="constants.duplex"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" class="text-subtitle-1 font-weight-bold">
                Baños totales: {{banosTotales()}}
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="caracteristicasInternas.banoDeServicio"
                                label="Baño de servicio"
                                :items="constants.serviceBathroom"
                                clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="caracteristicasInternas.banoSocial"
                                label="Baño social"
                                :items="constants.bathrooms"
                                :rules="[rules.required]"
                                clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="caracteristicasInternas.banoDeAlcobas"
                                label="Baño de alcobas"
                                :items="constants.bathrooms"
                                :rules="[rules.required]"
                                clearable>
                </v-select>
            </v-col>

            <v-col cols="12" class="text-subtitle-1 font-weight-bold">
                {{espaciosOAlcobas}} totales: {{alcobasTotales()}}
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete v-model="caracteristicasInternas.alcobas"
                                :label="espaciosOAlcobas"
                                :items="constants.bedrooms"
                                multiple
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete label="Alcoba de servicio"
                                :items="constants.serviceBedroom"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Comedor"
                                :items="constants.diningRoom"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Salón"
                                :items="constants.livingRoom"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Biblioteca"
                                :items="constants.library"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Estar"
                                :items="constants.livingRoom"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Balcón"
                                :items="constants.balcony"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Cocina"
                                :items="constants.kitchen"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Zona de ropa"
                                :items="constants.clothingArea"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Garaje"
                                :items="constants.garage"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Cuarto útil"
                                :items="constants.utilityRoom"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Calentador de agua"
                                :items="constants.waterHeater"
                                :rules="[rules.required]"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field label="Material pisos"
                              :rules="[rules.required]">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete label="Tipo de gas"
                                :items="constants.gasType"
                                :rules="[rules.required]">
                </v-autocomplete>
            </v-col>

            <v-col cols="12">
                <v-combobox :items="constants.otherInternalCharacteristics"
                            label="Otras"
                            multiple
                            deletable-chips
                            chips>
                </v-combobox>
            </v-col>

            <v-col cols="12">
                <v-textarea label="Notas internas (Solo para asesores)">

                </v-textarea>
            </v-col>

            <v-col cols="12">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="abadPrimary" @click="submit">Continuar</v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapState } from 'vuex'
import constants from '@/pages/RealEstate/libs/constants.js'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      datos: state => state.realEstate.datos
    }),
    espaciosOAlcobas () {
      return this.datos.tipoDePropiedad === 'Local' || this.datos.tipoDePropiedad === 'Bodega' || this.datos.tipoDePropiedad === 'Oficina' ? 'Espacios' : 'Alcobas'
    }
  },
  data () {
    return {
      caracteristicasInternas: {
        pentHouse: '',
        duplex: '',
        banoDeServicio: '',
        banoSocial: '',
        banoDeAlcobas: '',
        alcobas: '',
        alcobaDeServicio: '',
        comedor: '',
        salon: '',
        biblioteca: '',
        estar: '',
        balcon: '',
        cocina: '',
        zonaDeRopas: '',
        garage: '',
        cuartoUril: '',
        calentadorDeAgua: '',
        materialPisos: '',
        otras: ''
      },
      constants,
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      const stateForm = this.$refs.caracteristicasInternas.validate()
      this.$emit('updateStateForm', stateForm)
      if (!stateForm) return

      console.log('estoy aqui')
    },
    alcobasTotales () {
      const alcobas = this.caracteristicasInternas.alcobas && this.caracteristicasInternas.alcobas !== 'No Aplica' ? parseInt(this.caracteristicasInternas.alcobas, 10) : 0
      return alcobas
    },
    banosTotales () {
      const banoDeServicio = this.caracteristicasInternas.banoDeServicio === 'Si' ? 1 : 0
      const banoSocial = this.caracteristicasInternas.banoSocial && this.caracteristicasInternas.banoSocial !== 'No Aplica' ? parseInt(this.caracteristicasInternas.banoSocial, 10) : 0
      const banoDeAlcobas = this.caracteristicasInternas.banoDeAlcobas && this.caracteristicasInternas.banoDeAlcobas !== 'No Aplica' ? parseInt(this.caracteristicasInternas.banoDeAlcobas, 10) : 0

      return banoDeServicio + banoSocial + banoDeAlcobas
    }
  }
}
</script>
